var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 20,
    viewBox: "0 0 4 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.00067 3.33336C2.92116 3.33336 3.66736 2.58716 3.66736 1.66668C3.66736 0.746198 2.92116 0 2.00067 0C1.08019 0 0.333984 0.746198 0.333984 1.66668C0.333984 2.58716 1.08019 3.33336 2.00067 3.33336Z",
    fill: "#9B7CC8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.00067 11.6654C2.92116 11.6654 3.66736 10.9192 3.66736 9.99872C3.66736 9.07823 2.92116 8.33203 2.00067 8.33203C1.08019 8.33203 0.333984 9.07823 0.333984 9.99872C0.333984 10.9192 1.08019 11.6654 2.00067 11.6654Z",
    fill: "#9B7CC8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.00067 20.0014C2.92116 20.0014 3.66736 19.2551 3.66736 18.3347C3.66736 17.4142 2.92116 16.668 2.00067 16.668C1.08019 16.668 0.333984 17.4142 0.333984 18.3347C0.333984 19.2551 1.08019 20.0014 2.00067 20.0014Z",
    fill: "#9B7CC8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/threeDots.fc59a0a7298dfe27168b793232f2afda.svg";
export { ForwardRef as ReactComponent };